/*global analytics*/
import React, { Component } from "react";

export default class ShareFacebook extends Component {

    handleClick = () => {
        const {url} = this.props;
        const h=651, w=600;
        const top = window.top.outerHeight/2 + window.top.screenY - (h/2);
        const left = window.top.outerWidth/2 + window.top.screenX - (w/2);
        window.open("https://www.facebook.com/sharer.php?u=" + url, "", "height=" + h + ",width=" + w + ",left=" + left + ",top=" + top + ",menubar=0,toolbar=0");

        analytics.track('Clicked Element', {
        element_name: 'Facebook Share'
        });

    }
    render() {
        return (
            <div className="smb__icon smb__icon--facebook" 
                onClick={this.handleClick}
                title="Share on Facebook"
            >
            <i className="fab fa-facebook-f"></i>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/Components/ShareMyBox/ShareFacebook/ShareFacebook.js